import React, { useState } from "react";
import { Link } from "react-router-dom";
import avatar from "../images/avatar copy.png";

import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Divider,
  List,
  Typography,
  Box,
  Fab,
} from "@material-ui/core";

import MenuIcon from "@material-ui/icons/Menu";
import {
  Home,
  AssignmentInd,
  Apps,
  ContactMail,
  Description,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  menuSliderContainer: {
    width: 260,
    background: "#121212",
    height: "100%",
    paddingTop: "1.5rem",
  },
  avatar: {
    display: "block",
    margin: "1rem auto",
    width: theme.spacing(14),
    height: theme.spacing(14),
    border: "3px solid #00e0ff",
  },
  listItem: {
    color: "#e0e0e0",
    "&:hover": {
      color: "#00e0ff",
    },
  },

  // Floating hamburger button
  floatingMenu: {
    position: "fixed",
    top: 20,
    left: 20,
    background: "#00e0ff",
    color: "#000",
    zIndex: 2000,
    width: 50,
    height: 50,
    borderRadius: "50%",
    boxShadow: "0 0 15px #00e0ff, 0 0 30px rgba(0, 224, 255, 0.4)",
    animation: `$pulse 2.2s infinite ease-in-out`,
    transition: "0.25s ease-in-out",
    "&:hover": {
      transform: "scale(1.12)",
      boxShadow: "0 0 25px #00e0ff, 0 0 40px rgba(0, 224, 255, 0.8)",
      background: "#05f0ff",
    },
  },
  "@keyframes pulse": {
    "0%": { boxShadow: "0 0 10px #00e0ff, 0 0 20px rgba(0, 224, 255, 0.3)" },
    "50%": { boxShadow: "0 0 18px #00e0ff, 0 0 35px rgba(0, 224, 255, 0.55)" },
    "100%": { boxShadow: "0 0 10px #00e0ff, 0 0 20px rgba(0, 224, 255, 0.3)" },
  },
}));

const menuItems = [
  { listIcon: <Home />, listText: "Home", listPath: "/" },
  { listIcon: <AssignmentInd />, listText: "Resume", listPath: "/resume" },
  { listIcon: <Apps />, listText: "Projects", listPath: "/projects" },
  { listIcon: <ContactMail />, listText: "Contacts", listPath: "/contacts" },
  { listIcon: <Description />, listText: "Blogs", listPath: "/blogs" },
];

const Navbar = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  const sideList = () => (
    <Box
      className={classes.menuSliderContainer}
      component="div"
      onClick={toggleDrawer(false)}
    >
      <Avatar src={avatar} className={classes.avatar} />
      <Typography
        variant="h6"
        align="center"
        style={{ color: "#00e0ff", fontFamily: "Quicksand" }}
      >
        Pukar Upreti
      </Typography>

      <Divider style={{ background: "#333", marginTop: "1rem" }} />

      <List>
        {menuItems.map((item, key) => (
          <ListItem
            button
            key={key}
            component={Link}
            to={item.listPath}
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listItem}>
              {item.listIcon}
            </ListItemIcon>
            <ListItemText primary={item.listText} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      {/* Floating hamburger icon */}
      <Fab
        size="medium"
        className={classes.floatingMenu}
        onClick={!open ? toggleDrawer(true) : toggleDrawer(false)}
      >
        <MenuIcon />
      </Fab>

      {/* Side Drawer */}
      <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
        {sideList()}
      </Drawer>
    </>
  );
};

export default Navbar;
